<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/cms/slideBanner")
          i.fas.fa-list
          span.ml-1 {{ $t("ui.slide_banner") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row.col-md-12
            div(width="60%").mr-3
              b-button(v-b-modal.addSlideBanner type="button" variant="primary" size="sm" :disabled="loading").mr-3
                i.fa.fa-plus
                span {{ $t("ui.combine.add_slide_banner") }}
            div(width="20%").mr-3
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $t('ui.status') }}
                b-form-select(v-model="bannerStatus" @change="getBannerList(true)" :disabled="loading")
                  option(value=0) {{ $t('ui.all') }}
                  option(value=1) {{ $t('ui.active') }}
                  option(value=-1) {{ $t('ui.inactive') }}
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.en_img_desktop')") {{ $t("ui.en_img_desktop") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.fil_img_desktop')") {{ $t("ui.fil_img_desktop") }}
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.en_img_mobile')") {{ $t("ui.en_img_mobile") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.fil_img_mobile')") {{ $t("ui.fil_img_mobile") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.target')") {{ $t("ui.target") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.login_required')") {{ $t("ui.login_required") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.from')") {{ $t("ui.from") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.to')") {{ $t("ui.to") }}
                      th.sticky-position.sortable(width="8%" @click="sortOrder('item_order')")
                        span(:title="$t('ui.order')") {{ $t("ui.order") }}
                        i(:class="changeSortKey('item_order')")
                      th.text-center.sticky-position.sticky-toggle(width="6%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      th.text-center.sticky-position(width="9%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                      th.text-right.sticky-position(width="8%")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  tbody.clusterize-content
                    tr(v-if="bannerList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in bannerList")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(v-if="item.en_image_url_desktop")
                          b-img(:src="imagePath + item.en_image_url_desktop" style="width:100%;height:100%;")
                      td
                        span(v-if="item.fil_image_url_desktop")
                          b-img(:src="imagePath + item.fil_image_url_desktop" style="width:100%;height:100%;")
                      td
                        span(v-if="item.en_image_url_mobile")
                          b-img(:src="imagePath + item.en_image_url_mobile" style="width:100%;height:100%;")
                      td
                        span(v-if="item.fil_image_url_mobile")
                          b-img(:src="imagePath + item.fil_image_url_mobile" style="width:100%;height:100%;")
                      td
                        span(:title="item.target_window") {{ getTargetWindow(item.target_window) }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.login_required, 'fas fa-times text-warning': !item.login_required  }")
                      td
                        span(:title="$moment(item.active_from).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.active_from") {{ $moment(item.active_from).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span(:title="$moment(item.active_to).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.active_to") {{ $moment(item.active_to).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span(:title="item.item_order") {{ item.item_order }}
                      td
                        div.d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="item.status" @change="changedBannerStatus(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                      td.actions
                        span
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                        span
                          a.fa.fa-trash.text-danger(href="javascript:void(0)" @click="onDelete(item)" :title="$t('ui.delete')")
                        span
                          a.fa.fa-sync.text-secondary(href="javascript:void(0)" @click="onMove(item)" :title="$t('ui.move')")
                        span
                          a.fa.fa-arrow-up.text-success(href="javascript:void(0)" @click="onUpDown(item, true)" :title="$t('ui.move_up')")
                        span
                          a.fa.fa-arrow-down.text-info(href="javascript:void(0)" @click="onUpDown(item, false)" :title="$t('ui.move_down')")
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    addslidebanner(@clicked="addSlideBanner" @failed="handleFailed")
    editslidebanner(ref="editslidebanner" :item="editSelectedBanner" @clicked="afterEditBanner" @failed="handleFailed")
    moveslidebanner(ref="moveslidebanner" :item="editSelectedBanner" @clicked="afterMoveBanner" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addslidebanner from "@/components/cms/addSlideBanner.vue";
import editslidebanner from "@/components/cms/editSlideBanner.vue";
import moveslidebanner from "@/components/cms/moveSlideBanner.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addslidebanner,
    editslidebanner,
    moveslidebanner
  },
  data: () => ({
    loading: false,
    bannerList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "item_order",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBanner: null,
    bannerStatus: 1,
    imagePath: config.viewImageUrl
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountId == config.superUser;
    },
  },
  mounted: function() {
    this.getBannerList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getBannerList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    afterEditBanner: function(item) {
      this.getBannerList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_slide_banner"), this.$t("message.success"), "success");
    },
    afterMoveBanner: function(item) {
      this.getBannerList();
      this.$helpers.showDialog(this.$t("ui.combine.move_slide_banner"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedBanner = e;
      this.$refs.editslidebanner.$refs.editSlideBanner.show();
    },
    onMove(e) {
      this.editSelectedBanner = e;
      this.$refs.moveslidebanner.$refs.moveSlideBanner.show();
    },
    onDelete: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_banner_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBannerDelete(item);
          }
        });
    },
    confirmBannerDelete: function(item, isUp) {
      let url = config.cmsSlideBannerDeleteUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        banner_id: item.id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getBannerList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBannerList: function(isSearch) {
      let url = config.cmsSlideBannerListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.bannerStatus == 1) {
        json.banner_status = true;
      } else if (this.bannerStatus == -1) {
        json.banner_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bannerList = response.data.dt;
                this.totalRow = this.bannerList.length > 0 ? this.bannerList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedBannerStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_banner_status_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBannerStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBannerStatus: function(item, status) {
      let url = config.cmsSlideBannerStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        banner_id: item.id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getBannerList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUpDown: function(item, isUp) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_banner_" + (isUp == true ? 'up' : 'down') + "_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBannerUpDown(item, isUp);
          }
        });
    },
    confirmBannerUpDown: function(item, isUp) {
      let url = config.cmsSlideBannerUpDownUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        banner_id: item.id,
        direction: isUp,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getBannerList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addSlideBanner: function() {
      this.getBannerList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_slide_banner"), this.$t("message.success"), "success");
    },
    getTargetWindow: function(type) {
      if (type == "_blank")
        return this.$t("ui.new_window_tab")
      else if (type == "_self")
        return this.$t("ui.current_page")

      return "";
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getBannerList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBannerList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
hr {
  margin-top:0em !important;
  margin-bottom:0em !important;
  width: 50% !important;
}

.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

.red-bg {
  background-color: lightcoral !important
}

td {
  vertical-align: middle !important;
}
</style>